/*
 * Readable ink for a saturated fill, by measurement (port of the wedge rvInkOn). A fixed per-theme ink fails on
 * some rep-selectable accents: #04140C ink on the mono accent is 1.12:1, the static token on terracotta is 2.87:1.
 * Compares WCAG contrast of pure white vs the canvas ink #0A1A10 (luminance 0.0085) and returns the better one.
 */
export const DARK_INK = '#0A1A10';
export const LIGHT_INK = '#FFFFFF';

const channel = (hex: string, i: number): number => {
  const c = parseInt(hex.slice(i, i + 2), 16) / 255;
  return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
};

export const luminance = (hex: string): number | null => {
  const m = /^#?([0-9a-f]{6})$/i.exec(String(hex || '').trim());
  if (!m) return null;
  const v = m[1];
  return 0.2126 * channel(v, 0) + 0.7152 * channel(v, 2) + 0.0722 * channel(v, 4);
};

export const contrast = (a: string, b: string): number | null => {
  const la = luminance(a);
  const lb = luminance(b);
  if (la === null || lb === null) return null;
  const [hi, lo] = la > lb ? [la, lb] : [lb, la];
  return (hi + 0.05) / (lo + 0.05);
};

export const inkOn = (fillHex: string, fallback: string): string => {
  const L = luminance(fillHex);
  if (L === null) return fallback;
  const onLight = 1.05 / (L + 0.05);
  const onDark = (L + 0.05) / (0.0085 + 0.05);
  return onLight >= onDark ? LIGHT_INK : DARK_INK;
};
